import {Component, Show, createSignal } from 'solid-js';
import { CMSBlock, CMSProviderType, useCMS } from './provider';

export interface cmsProps {
    id: string;
    text?: boolean;
    data?: Record<string,string>;
    children?: any;
}
export const plainText = (html: string) => {
    const div = document.createElement("DIV");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
}
export const CMS : Component<cmsProps> = (props) => {
    const provider = useCMS() as CMSProviderType;
    const cmsValue = provider?.cms[props.id];
    if (!cmsValue) {
        if (provider.setCms) {
            provider.setCms(props.id, { found: false, item: props.children });
        }
    }
    const bindData = (block: CMSBlock) => {
        if (!block) return null;
        if (!props.data) return block.item;
        if (!block.found) return null;
        let text = block.item;
        for (let key in props.data) {
            text = text.replace(new RegExp('{' + key + '}', 'gi'), props.data[key]);
        }
        return text;
    };
    const [value, setValue] = createSignal<string>(bindData(cmsValue) || "");
    return (
        <>
            <Show when={cmsValue?.found}>
                <Show when={props.text}>
                    <span innerText={plainText(value())} />
                </Show>
                <Show when={!props.text}>
                    <span innerHTML={value()} />
                </Show>
            </Show>
            <Show when={!cmsValue?.found}>
                {props.children}
            </Show>
        </>
    )
}